import React from "react";
import { node, string } from "prop-types";
import Button from "../Button";

const SectionTryForFreeLink = ({ href, children, ...props }) => {
	return (
		<Button.Link href={href} size="s" className="section-try-for-free__link" {...props}>
			{children}
		</Button.Link>
	);
};

SectionTryForFreeLink.propTypes = {
	href: string.isRequired,
	children: node.isRequired,
};

export default SectionTryForFreeLink;
